import { useEffect } from "react";

/**
 * Locks body scroll without causing a layout shift / flicker.
 * The width of the (removed) scrollbar is compensated with padding so the
 * page underneath never jumps when a modal opens or closes.
 */
export function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;

    const body = document.body;
    const previousOverflow = body.style.overflow;
    const previousPaddingRight = body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      const current = parseFloat(getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${current + scrollbarWidth}px`;
    }

    return () => {
      body.style.overflow = previousOverflow;
      body.style.paddingRight = previousPaddingRight;
    };
  }, [active]);
}
